import React, { Component } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { Grid, Paper, Button, Link } from '@material-ui/core';
import DataTable from '../../components/DataTable/DataTable'
import styles from '../App.css';
import Translation from '../../components/Translation/Translation';

@inject('customerCaseStore')
@observer
export default class Users extends Component
{
  constructor(props) {
    super(props);

    this.state = {
      head: [
        <Translation>username</Translation>,
        <Translation>email</Translation>,
        <Translation>firstName</Translation>,
        <Translation>lastName</Translation>,
        <Translation>templateRightsLevel</Translation>
      ],
      users: []
    };

    this.searchParam = null;
    this.allUsers = [];
  }

  onSearch(val) {
    this.searchParam = val.trim().toLowerCase();
    this.updateFilteredTemplates();
  }

  updateFilteredTemplates() {
    let users = this.allUsers;

    if (this.searchParam && this.searchParam !== "") {
      users = this.allUsers.filter(user => {
        let searchValues = [user.username.props.children, user.email, user.firstName, user.lastName];
        return searchValues.reduce(
          (acc, val) => (acc || val.trim().toLowerCase().includes(this.searchParam)),
          false
        );
      });
    }

    this.setState({users});
  }

  add() {
    this.props.history.push('/create/user');
  }

  componentDidMount() {
    this.props.customerCaseStore.getUsers()
      .then((users) => {
        var prettyUsers = users.map(user => {
          return {
            username: (<Link to={`/users/${user._id}`} component={RouterLink}>{user.username}</Link>),
            email: user.userInformation.email,
            firstName: user.userInformation.firstName,
            lastName: user.userInformation.lastName,
            templateRightsLevel: <Translation>{`privileges.${user.templateRightsLevel}`}</Translation>,
          }
        });

        this.allUsers = prettyUsers;

        this.setState({users: prettyUsers});
      })
  }

  renderData() {
    const { head, users } = this.state;

    return (
      <DataTable
        head={head}
        data={users}
        onSearch={this.onSearch.bind(this)}
      />
    )
  }

  render() {
    return (
      <Grid item xs={12}>
        {this.renderData()}

        <Button style={styles.marginTop} onClick={this.add.bind(this)} variant="raised" color="primary">{<Translation>nav.addNewUser</Translation>}</Button>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx